import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'

import {AxiosError} from 'axios'

import ColumnChartComponent from './ColumnChartComponent'
import {useIntl} from 'react-intl'
import {useSelectDeviceId, useSelectInputSectionValue} from '../../../_metronic/layout/core'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {awsHomeSubscribeData, awsHomeSubscribeDataMulti} from '../../modules/auth/core/_requests'

function ReadSensor({
  item,
  title,
  deviceCode,
  chartIndex,
  extraGraphics,
  experimentId,
  circuitId,
}: any) {
  // const localSelectDevice = Number(window.localStorage.getItem('selectDevice'))
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  const {SelectInputSectionValue} = useSelectInputSectionValue()
  const [checkboxValues, setCheckboxValues] = useState<boolean[]>(item.map(() => false))
  const [ListenCheckboxValues, setListenCheckboxValues] = useState(false)
  const [chartValues, setChartValues] = useState<Array<number>>([0, 0, 0])
  const [chartArrayValues, setChartArrayValues] = useState<Array<any>>([])
  const {SelectDeviceId} = useSelectDeviceId()
  // const [dataToBeSent, setDataToBeSent] = useState<number[][]>()
  const [action, setAction] = useState(false)
  const lang = useLang()
  const intl = useIntl()

  const UnsuccessfulNotify = (message: string) =>
    toast.error(`${message}`, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    })

  useEffect(() => {
    setCheckboxValues(item.map(() => false))
  }, [item])

  const handleCheckboxChange = (index: number) => {
    setCheckboxValues((prevValues: any) =>
      prevValues.map((value: any, i: any) => (i === index ? !value : value))
    )
  }

  const checkedIndexes = checkboxValues
    .map((value: any, index: any) => (value ? index : null))
    .filter((index: any) => index !== null)

  const sendAwsData = async (numArr: any) => {
    try {
      /* const deviceId = SelectDeviceId[0] ?? localSelectDevices[0] ?? 0
      const {data} = await awsHomeSubscribeData(experimentId, circuitId, deviceId, {
        device: deviceCode,
        degerlers: numArr,
      })*/

      const {data} = await awsHomeSubscribeDataMulti(experimentId, circuitId, SelectDeviceId, {
        device: deviceCode,
        degerlers: numArr,
      })
      setChartArrayValues(data)
      //setChartValues(data)
      //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
      // console.log(data)
      //
      setAction(true)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  function handleListenCheckboxChange() {
    if (localSelectDevice) {
      setListenCheckboxValues((prevValues: any) => !prevValues)
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  function handleReadValue() {
    if (localSelectDevice) {
      /* if (dataToBeSent) {
        console.log(dataToBeSent)
        //  sendAwsData(dataToBeSent)
        /* setChartValues([
          Math.floor(Math.random() * 100),
          Math.floor(Math.random() * 100),
          Math.floor(Math.random() * 100),
        ])
      }*/

      /*setChartValues([
        parseFloat((Math.random() * 100).toFixed(2)),
        parseFloat((Math.random() * 100).toFixed(2)),
        parseFloat((Math.random() * 100).toFixed(2)),
      ])*/
      let data: number[][] = printValues2(SelectInputSectionValue)
      sendAwsData(data)
      //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
      //  console.log(data)
      //
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  useEffect(() => {
    if (ListenCheckboxValues) {
      const intervalId = setInterval(() => {
        handleReadValue()
      }, 2000)
      return () => clearInterval(intervalId)
    }
  }, [ListenCheckboxValues])

  function printValues2(prevSectionsValue: any) {
    let printData: number[][] = []
    item.map((i: any) => {
      let value = i.value
      const regex = /\[(.*?)\]/g
      let match: any
      const result: any = []
      while ((match = regex.exec(value))) {
        let str = match[1]
        let data = str.split(',').map(Number)
        result.push(data)
      }
      result.forEach((data: any) => {
        printData.push(data)
      })
    })

    if (prevSectionsValue.length > 0) {
      prevSectionsValue.forEach((item1: any) => {
        if (Array.isArray(item1) && item1.length > 0) {
          item1.forEach((item2) => {
            if (Array.isArray(item2) && item2.length > 0) {
              item2.forEach((value) => {
                printData.push(value)
              })
            }
          })
        }
      })
    }

    /* Buradan sonra işlem kodları eklenecek*/

    // console.log(printData)
    return printData
  }

  // 👇 Mobil Görünümde Grafiklerin Alt Alta Geçmesi
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768)
    }

    // Pencere boyutu değiştiğinde yeniden boyutlandırmayı dinle
    window.addEventListener('resize', handleResize)

    // Temizleme fonksiyonunu döndürerek event listener'ı temizle
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  // 👆 Mobil Görünümde Grafiklerin Alt Alta Geçmesi

  return (
    <div
      className='col-xl-12 col-12 mb-5 mb-xl-0 sal-animate'
      data-sal-delay='200'
      data-sal='slide-up'
      data-sal-duration='500'
      style={{position: 'relative'}}
    >
      <div className='card card-flush h-100 border'>
        <div className='card-header pt-5'>
          <h3 className='card-title text-gray-800 fw-bold'>{title}</h3>
        </div>
        <div className='card-body pt-0'>
          <div className='card-toolbar d-flex align-items-center justify-content-end mb-5'>
            <div className='d-flex align-items-center form-check form-check-success form-check-solid me-4'>
              <input
                className='form-check-input h-30px w-30px me-2 continuously-chart'
                type='checkbox'
                name={`flexCheckBoxListen`}
                id={`flexCheckBoxListen`}
                checked={ListenCheckboxValues}
                onChange={() => handleListenCheckboxChange()}
              />

              <label className='form-check-label fw-bold' htmlFor={`flexCheckBoxListen`}>
                {lang === 'tr' ? 'Sürekli' : 'Continuously'}
              </label>
            </div>
            <div>
              <button
                type='button'
                className='btn btn-success btn-sm read-button-chart'
                onClick={() => handleReadValue()}
              >
                {lang === 'tr' ? 'Oku' : 'Read'}
              </button>
            </div>
          </div>
          <div className='container mt-3'>
            <div id='chartdiv  '>
              <div className={`position-relative w-100 h-100 row `}>
                {item.map((itemInformation: any, index: number) => (
                  <div key={index} className='col-6'>
                    <h2 style={{paddingLeft: '20px'}}>{itemInformation.key}</h2>

                    <ColumnChartComponent
                      dataIndex={index}
                      chartIndex={extraGraphics ? `ekstra-${chartIndex}` : chartIndex + index}
                      action={action}
                      setAction={setAction}
                      chartValues={[chartValues[index], 0, 0]}
                      chartArrayValues={chartArrayValues}
                      // graphicInformation={item}
                      graphicInformation={Array(itemInformation)}
                      extraGraphics={extraGraphics}
                      maxValue={itemInformation.maxValue}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReadSensor
